import axios from "axios";
import router from "../router/index";
import { Message } from "element-ui";
import { setTimeout } from "core-js";
import dayjs from "dayjs";
import { addLogininfor } from "@/api/home/nav";

let baseURL =
  process.env.NODE_ENV == "production"
    ? // ? "http://192.168.3.126:8083/"
      // : "http://192.168.3.126:8083/";
      // ? "http://8.141.86.51:17011/"
      // : "http://8.141.86.51:17011/";
      // 博喻线上
      // ? "http://101.200.217.153:8086/"
      // : "http://101.200.217.153:8086/";
      // 云服务器
      // ? "http://8.141.86.51:8081/"
      // : "http://8.141.86.51:8081/";
      "https://yingtongsudu.com/prod-api/"
    : "https://yingtongsudu.com/prod-api/";
// 经开外国语
// ? "http://10.210.48.227:8081/"
// : "http://10.210.48.227:8081/";
// 经开五中
// ? "http://10.212.175.244:8081/"
// : "http://10.212.175.244:8081/";

// 创建基础地址
// console.log("2process.env.NODE_ENV2", process.env.NODE_ENV);
const service = axios.create({
  baseURL,
  timeout: 5000, // 请求超时时间
});
// const token = sessionStorage.getItem('token')
service.defaults.headers.post["Content-Type"] = "application/json";
// service.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    let token = sessionStorage.getItem("token");
    if (token !== "") {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (err) => {
    console.log(err);
    return Promise.reject(err);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // console.log(res);
    if (res.data.code === 200) {
      return res.data;
    } else if (res.data.code === 401) {
      let user = JSON.parse(sessionStorage.getItem("userInfo"));
      if (user != null) {
        let obj1 = {
          userName: user.userName,
          msg: "异常退出",
          loginTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        };
        addLogininfor(obj1).then((res) => {});
      }
      sessionStorage.removeItem("userInfo");
      sessionStorage.removeItem("activeIndex");
      sessionStorage.removeItem("nextLevel");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("autonomous");
      sessionStorage.removeItem("headImg");
      sessionStorage.removeItem("courseDetail");
      router.replace({ path: "/home" });
      setTimeout(() => {
        location.reload();
      }, 100);
    } else if (res.data.code === 500 && res.data.msg != null) {
      Message({
        message: res.data.msg,
        type: "error",
        duration: 2 * 1000,
      });
    }
    // if(res.status === 500 ){
    //   Message({
    //       message: res.data.msg,
    //       type: "error",
    //       duration: 2 * 1000
    //   });
    // }
    Promise.reject(res.data);
  },
  (err) => {
    // console.log(err);
    Message({
      message: "请求错误",
      type: "error",
      duration: 2 * 1000,
    });
    return Promise.reject(err);
  }
);
export default service;
